import { makeStyles } from '@material-ui/core/styles';

export const useBulkTypeOptionsStyles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(0, 0, 0.5, 0),
    '& *': {
      margin: theme.spacing(-0.25, 0)
    }
  }
}));
